module.exports = __webpack_public_path__ + "static/veri-toplama-157b37eb73de9c4a9464f06cbe0cf953.png";